import React from 'react';
import PropTypes from 'prop-types';
/** renders a label at the top of a cards list */

var CardsLabel = function CardsLabel(_ref) {
  var children = _ref.children,
      _ref$labelPosition = _ref.labelPosition,
      labelPosition = _ref$labelPosition === void 0 ? 'center' : _ref$labelPosition;
  return /*#__PURE__*/React.createElement("h2", {
    className: "cards-label cards-label-".concat(labelPosition)
  }, children);
};

CardsLabel.displayName = "CardsLabel";
CardsLabel.propTypes = {
  children: PropTypes.node,
  labelPosition: PropTypes.string
};
export { CardsLabel };